'use client'
import { useMemo, type FC } from 'react'
import styled from 'styled-components'
import { mq, vw } from '@/styles'
import { usePathname } from 'next/navigation'
import { getRelatedCols } from '@/utils'
import { SectionTwoCols } from './SectionTwoCols'

const checkPath = (pathname: string) => {
  if(pathname.includes('collections')) return pathname
  else {
    return `/collections/${pathname}`
  }
}
export const WrapperCollection:FC = ({ }) => {
  const pathname = usePathname()
  const pathToCheck = useMemo(() => checkPath(pathname), [pathname])

  return (
    <Wrapper $collection={true}>
      <SectionTwoCols cols={getRelatedCols(pathToCheck)} />
    </Wrapper>
  )
}

const Wrapper = styled.div<{ $collection: boolean }>`
  margin-bottom: ${({ $collection }) => $collection ? vw(100, 'mobile') : '0' };
  margin-top: ${({ $collection }) => $collection ? vw(100, 'mobile') : '0' };

  ${mq.greaterThan('tablet')} {
    margin-bottom: ${({ $collection }) => $collection ? vw(130, 'desktop') : '0' };
    margin-top: ${({ $collection }) => $collection ? vw(130, 'desktop') : '0' };
  }
`
